export default function ssnValidator(value) {
  return `${value}`.match(/^\d{5}$/);
}
